import{expandTokens}from"./expand.js";
import{groupBy}from"./group.js";


export const iterateChildEntries=function*({
entries,
parentEntry,
index,
parents,
opts,
iterateLevel
}){
if(!shouldIterateChildren(entries,parentEntry,opts)){
return false
}


let hasChildren=false;


for(const childEntry of iterateChildren({
entries,
index,
parents,
opts,
iterateLevel
})){

hasChildren=true;
yield childEntry
}

return hasChildren
};

const shouldIterateChildren=(entries,parentEntry,{roots})=>
parentEntry===undefined||entries.length!==1&&!roots;

const iterateChildren=function*({
entries,
index,
parents,
opts,
iterateLevel
}){
const childEntries=expandTokens(entries,index,opts);

if(childEntries.length===0){
return
}

const indexA=index+1;

if(childEntries.length===1){
yield*iterateLevel({entries:childEntries,index:indexA,parents,opts});
return
}

const childEntriesGroups=groupSortChildEntries(childEntries,opts);


for(const childEntriesA of childEntriesGroups){
yield*iterateLevel({
entries:childEntriesA,
index:indexA,
parents,
opts
})
}
};







const groupSortChildEntries=(childEntries,{sort})=>{
const childEntriesObj=groupBy(childEntries,getLastProp);
return sort?

Object.keys(childEntriesObj).
sort().
map((prop)=>childEntriesObj[prop]):
Object.values(childEntriesObj)
};

const getLastProp=({path})=>path.at(-1);